<template>
  <div>
    
    <!-- Widget Cards -->
    <div class="cards-widget">
      <div class="container">
        <div class="cw-row">
          <img v-if="row.image1" :src="row.image1" class="img-fluid" :alt="row.title1" />
          <div class="cw-details">
            <div class="sub-title gray-color mb-2"
                v-html="row.subTitle1"
                :style="'color:'+row.subTitleColor1+' !important'">
            </div>
            <div class="bg-title main-color mb-3" 
                v-html="row.title1"
                :style="'color:'+row.color1+' !important'">
            </div>
            <div class="text gray-color mb-4" 
                v-html="row.content1"
                :style="'color:'+row.contentColor1+' !important'">
              </div>
            <router-link v-if="row.button1" :to="row.redirect1"
                class="btn-line btn-line-gray">{{ row.button1 }}
            </router-link>
          </div>
        </div>

        <div class="cw-row">
          <img v-if="row.image2" :src="row.image2" class="img-fluid" :alt="row.title2" />
          <div class="cw-details">
            <div class="sub-title gray-color mb-2" 
                v-html="row.subTitle2"
                :style="'color:'+row.subTitleColor2+' !important'">
            </div>
            <div class="bg-title main-color mb-3"
                v-html="row.title2"
                :style="'color:'+row.color2+' !important'">
            </div>
            <div class="text gray-color mb-4"
                v-html="row.content2"
                :style="'color:'+row.contentColor2+' !important'">
            </div>
            <router-link v-if="row.button2" :to="row.redirect2"
                class="btn-line btn-line-gray">{{ row.button2 }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- Widget Cards -->

  </div>
</template>

<script>
export default {
  name: "Section1",
  props: ['row'],
  components: {},
  data() {
    return {
      pgLoading: true,
    };
  },
  created() {
      //
  },
  methods: {
    //
  },
};
</script>
